module.exports = __webpack_public_path__ + "img/youtube.3220832d.svg";